import { gql } from "../../../gql"
import { useCallback } from "react"
import { useMutation } from "@oysterhr/core"
import { MutationPostStaffNoteArgs, PostStaffNotePayload } from "@oysterhr/schema"
import { STAFF_PROCESS_OVERVIEW_QUERY } from "./useStaffProcessOverviewData"

const CREATE_NOTE_MUTATION = gql(`
  mutation HiringProcessOvewviewStaffCreateNote($input: PostStaffNoteInput!) {
    postStaffNote(input: $input) {
      staffNote {
        ...StaffNoteDetails
      }
    }
  }
`)

export function useCreateNote() {
  const [_createNote, { data, error, loading }] = useMutation<
    { postStaffNote: PostStaffNotePayload },
    MutationPostStaffNoteArgs
  >(CREATE_NOTE_MUTATION, {
    refetchQueries: [STAFF_PROCESS_OVERVIEW_QUERY],
  })

  const createNote = useCallback(
    (hiringId: string, taskName: string, content: string) => {
      const postingContext = {
        entity_id: `${hiringId}`,
        scope: taskName,
      }

      return _createNote({
        variables: {
          input: {
            content: content,
            postingContext: Buffer.from(JSON.stringify(postingContext)).toString("base64"),
          },
        },
      })
    },
    [_createNote],
  )

  return {
    createNote,
    data,
    loading,
    error,
  }
}
